import { ChordModel, MajorChords, MinorChords, UnstableChords } from './all_chords_for_impro';

export default [
  [
    ['A', MinorChords.Minor, ['A', 'C', 'E'], ['B', 'D', 'E', 'F', 'G']],
    ['A', MinorChords.M7, ['A', 'C', 'E', 'G'], ['B', 'D', 'E', 'F', 'G']],
    ['A', UnstableChords.M9, ['A', 'C', 'E', 'G', 'B'], ['B', 'D', 'E', 'F', 'G']],
    ['A', UnstableChords.Min7b5, ['A', 'C', 'D#', 'G'], ['B', 'D#', 'D', 'F', 'G']],
    ['A', MinorChords.Madd9, ['A', 'C', 'E', 'G', 'B'], ['B', 'E', 'D', 'F', 'G']],
    ['A', MajorChords.Major, ['A', 'C#', 'E'], ['B', 'E', 'D', 'F#', 'G#']],
    ['A', UnstableChords.D7, ['A', 'C#', 'E', 'G'], ['B', 'E', 'D', 'F#', 'G']],
    ['A', UnstableChords.D7b5, ['A', 'C#', 'D#', 'G'], ['B', 'E', 'D', 'F#', 'G']],
    ['A', MajorChords.Maj7, ['A', 'C#', 'E', 'G#'], ['B', 'E', 'D', 'F#', 'G#']],
    ['A', MajorChords.MajAdd9, ['A', 'C#', 'E', 'G#', 'B'], ['B', 'E', 'D', 'F#', 'G#']],
    ['A', UnstableChords.Dim7, ['A', 'C', 'D#', 'F#'], ['A#', 'C', 'D#', 'D', 'F#', 'G']],
    ['A', UnstableChords.Aug, ['A', 'C#', 'F'], ['A', 'C#', 'F']],
  ],
  [
    ['A#', MinorChords.Minor, ['A#', 'C#', 'F'], ['C', 'D#', 'F', 'F#', 'G#']],
    ['A#', MinorChords.M7, ['A#', 'C#', 'F', 'G#'], ['C', 'D#', 'F', 'F#', 'G#']],
    ['A#', UnstableChords.M9, ['A#', 'C#', 'F', 'G#', 'C'], ['C', 'D#', 'F', 'F#', 'G#']],
    ['A#', UnstableChords.Min7b5, ['A#', 'C#', 'E', 'G#'], ['C', 'E', 'D#', 'F#', 'G#']],
    ['A#', MinorChords.Madd9, ['A#', 'C#', 'F', 'G#', 'C'], ['C', 'F', 'D#', 'F#', 'G#']],
    ['A#', MajorChords.Major, ['A#', 'D', 'F'], ['C', 'F', 'D#', 'G', 'A']],
    ['A#', UnstableChords.D7, ['A#', 'D', 'F', 'G#'], ['C', 'F', 'D#', 'G', 'G#']],
    ['A#', UnstableChords.D7b5, ['A#', 'D', 'E', 'G#'], ['C', 'F', 'D#', 'G', 'G#']],
    ['A#', MajorChords.Maj7, ['A#', 'D', 'F', 'A'], ['C', 'F', 'D#', 'G', 'A']],
    ['A#', MajorChords.MajAdd9, ['A#', 'D', 'F', 'A', 'C'], ['C', 'F', 'D#', 'G', 'A']],
    ['A#', UnstableChords.Dim7, ['A#', 'C#', 'E', 'G'], ['B', 'C#', 'E', 'D#', 'G', 'G#']],
    ['A#', UnstableChords.Aug, ['A#', 'D', 'F#'], ['A#', 'D', 'F#']],
  ],
  [
    ['B', MinorChords.Minor, ['B', 'D', 'F#'], ['C#', 'E', 'F#', 'G', 'A']],
    ['B', MinorChords.M7, ['B', 'D', 'F#', 'A'], ['C#', 'E', 'F#', 'G', 'A']],
    ['B', UnstableChords.M9, ['B', 'D', 'F#', 'A', 'C#'], ['C#', 'E', 'F#', 'G', 'A']],
    ['B', UnstableChords.Min7b5, ['B', 'D', 'F', 'A'], ['C#', 'F', 'E', 'G', 'A']],
    ['B', MinorChords.Madd9, ['B', 'D', 'F#', 'A', 'C#'], ['C#', 'F#', 'E', 'G', 'A']],
    ['B', MajorChords.Major, ['B', 'D#', 'F#'], ['C#', 'F#', 'E', 'G#', 'A#']],
    ['B', UnstableChords.D7, ['B', 'D#', 'F#', 'A'], ['C#', 'F#', 'E', 'G#', 'A']],
    ['B', UnstableChords.D7b5, ['B', 'D#', 'F', 'A'], ['C#', 'F#', 'E', 'G#', 'A']],
    ['B', MajorChords.Maj7, ['B', 'D#', 'F#', 'A#'], ['C#', 'F#', 'E', 'G#', 'A#']],
    ['B', MajorChords.MajAdd9, ['B', 'D#', 'F#', 'A#', 'C#'], ['C#', 'F#', 'E', 'G#', 'A#']],
    ['B', UnstableChords.Dim7, ['B', 'D', 'F', 'G#'], ['C', 'D', 'F', 'E', 'G#', 'A']],
    ['B', UnstableChords.Aug, ['B', 'D#', 'G'], ['B', 'D#', 'G']],
  ],
  [
    ['C', MinorChords.Minor, ['C', 'D#', 'G'], ['D', 'F', 'G', 'G#', 'A#']],
    ['C', MinorChords.M7, ['C', 'D#', 'G', 'A#'], ['D', 'F', 'G', 'G#', 'A#']],
    ['C', UnstableChords.M9, ['C', 'D#', 'G', 'A#', 'D'], ['D', 'F', 'G', 'G#', 'A#']],
    ['C', UnstableChords.Min7b5, ['C', 'D#', 'F#', 'A#'], ['D', 'F#', 'F', 'G#', 'A#']],
    ['C', MinorChords.Madd9, ['C', 'D#', 'G', 'A#', 'D'], ['D', 'G', 'F', 'G#', 'A#']],
    ['C', MajorChords.Major, ['C', 'E', 'G'], ['D', 'G', 'F', 'A', 'B']],
    ['C', UnstableChords.D7, ['C', 'E', 'G', 'A#'], ['D', 'G', 'F', 'A', 'A#']],
    ['C', UnstableChords.D7b5, ['C', 'E', 'F#', 'A#'], ['D', 'G', 'F', 'A', 'A#']],
    ['C', MajorChords.Maj7, ['C', 'E', 'G', 'B'], ['D', 'G', 'F', 'A', 'B']],
    ['C', MajorChords.MajAdd9, ['C', 'E', 'G', 'B', 'D'], ['D', 'G', 'F', 'A', 'B']],
    ['C', UnstableChords.Dim7, ['C', 'D#', 'F#', 'A'], ['C#', 'D#', 'F#', 'F', 'A', 'A#']],
    ['C', UnstableChords.Aug, ['C', 'E', 'G#'], ['C', 'E', 'G#']],
  ],
  [
    ['C#', MinorChords.Minor, ['C#', 'E', 'G#'], ['D#', 'F#', 'G#', 'A', 'B']],
    ['C#', MinorChords.M7, ['C#', 'E', 'G#', 'B'], ['D#', 'F#', 'G#', 'A', 'B']],
    ['C#', UnstableChords.M9, ['C#', 'E', 'G#', 'B', 'D#'], ['D#', 'F#', 'G#', 'A', 'B']],
    ['C#', UnstableChords.Min7b5, ['C#', 'E', 'G', 'B'], ['D#', 'G', 'F#', 'A', 'B']],
    ['C#', MinorChords.Madd9, ['C#', 'E', 'G#', 'B', 'D#'], ['D#', 'G#', 'F#', 'A', 'B']],
    ['C#', MajorChords.Major, ['C#', 'F', 'G#'], ['D#', 'G#', 'F#', 'A#', 'C']],
    ['C#', UnstableChords.D7, ['C#', 'F', 'G#', 'B'], ['D#', 'G#', 'F#', 'A#', 'B']],
    ['C#', UnstableChords.D7b5, ['C#', 'F', 'G', 'B'], ['D#', 'G#', 'F#', 'A#', 'B']],
    ['C#', MajorChords.Maj7, ['C#', 'F', 'G#', 'C'], ['D#', 'G#', 'F#', 'A#', 'C']],
    ['C#', MajorChords.MajAdd9, ['C#', 'F', 'G#', 'C', 'D#'], ['D#', 'G#', 'F#', 'A#', 'C']],
    ['C#', UnstableChords.Dim7, ['C#', 'E', 'G', 'A#'], ['D', 'E', 'G', 'F#', 'A#', 'B']],
    ['C#', UnstableChords.Aug, ['C#', 'F', 'A'], ['C#', 'F', 'A']],
  ],
  [
    ['D', MinorChords.Minor, ['D', 'F', 'A'], ['E', 'G', 'A', 'A#', 'C']],
    ['D', MinorChords.M7, ['D', 'F', 'A', 'C'], ['E', 'G', 'A', 'A#', 'C']],
    ['D', UnstableChords.M9, ['D', 'F', 'A', 'C', 'E'], ['E', 'G', 'A', 'A#', 'C']],
    ['D', UnstableChords.Min7b5, ['D', 'F', 'G#', 'C'], ['E', 'G#', 'G', 'A#', 'C']],
    ['D', MinorChords.Madd9, ['D', 'F', 'A', 'C', 'E'], ['E', 'A', 'G', 'A#', 'C']],
    ['D', MajorChords.Major, ['D', 'F#', 'A'], ['E', 'A', 'G', 'B', 'C#']],
    ['D', UnstableChords.D7, ['D', 'F#', 'A', 'C'], ['E', 'A', 'G', 'B', 'C']],
    ['D', UnstableChords.D7b5, ['D', 'F#', 'G#', 'C'], ['E', 'A', 'G', 'B', 'C']],
    ['D', MajorChords.Maj7, ['D', 'F#', 'A', 'C#'], ['E', 'A', 'G', 'B', 'C#']],
    ['D', MajorChords.MajAdd9, ['D', 'F#', 'A', 'C#', 'E'], ['E', 'A', 'G', 'B', 'C#']],
    ['D', UnstableChords.Dim7, ['D', 'F', 'G#', 'B'], ['D#', 'F', 'G#', 'G', 'B', 'C']],
    ['D', UnstableChords.Aug, ['D', 'F#', 'A#'], ['D', 'F#', 'A#']],
  ],
  [
    ['D#', MinorChords.Minor, ['D#', 'F#', 'A#'], ['F', 'G#', 'A#', 'B', 'C#']],
    ['D#', MinorChords.M7, ['D#', 'F#', 'A#', 'C#'], ['F', 'G#', 'A#', 'B', 'C#']],
    ['D#', UnstableChords.M9, ['D#', 'F#', 'A#', 'C#', 'F'], ['F', 'G#', 'A#', 'B', 'C#']],
    ['D#', UnstableChords.Min7b5, ['D#', 'F#', 'A', 'C#'], ['F', 'A', 'G#', 'B', 'C#']],
    ['D#', MinorChords.Madd9, ['D#', 'F#', 'A#', 'C#', 'F'], ['F', 'A#', 'G#', 'B', 'C#']],
    ['D#', MajorChords.Major, ['D#', 'G', 'A#'], ['F', 'A#', 'G#', 'C', 'D']],
    ['D#', UnstableChords.D7, ['D#', 'G', 'A#', 'C#'], ['F', 'A#', 'G#', 'C', 'C#']],
    ['D#', UnstableChords.D7b5, ['D#', 'G', 'A', 'C#'], ['F', 'A#', 'G#', 'C', 'C#']],
    ['D#', MajorChords.Maj7, ['D#', 'G', 'A#', 'D'], ['F', 'A#', 'G#', 'C', 'D']],
    ['D#', MajorChords.MajAdd9, ['D#', 'G', 'A#', 'D', 'F'], ['F', 'A#', 'G#', 'C', 'D']],
    ['D#', UnstableChords.Dim7, ['D#', 'F#', 'A', 'C'], ['E', 'F#', 'A', 'G#', 'C', 'C#']],
    ['D#', UnstableChords.Aug, ['D#', 'G', 'B'], ['D#', 'G', 'B']],
  ],
  [
    ['E', MinorChords.Minor, ['E', 'G', 'B'], ['F#', 'A', 'B', 'C', 'D']],
    ['E', MinorChords.M7, ['E', 'G', 'B', 'D'], ['F#', 'A', 'B', 'C', 'D']],
    ['E', UnstableChords.M9, ['E', 'G', 'B', 'D', 'F#'], ['F#', 'A', 'B', 'C', 'D']],
    ['E', UnstableChords.Min7b5, ['E', 'G', 'A#', 'D'], ['F#', 'A#', 'A', 'C', 'D']],
    ['E', MinorChords.Madd9, ['E', 'G', 'B', 'D', 'F#'], ['F#', 'B', 'A', 'C', 'D']],
    ['E', MajorChords.Major, ['E', 'G#', 'B'], ['F#', 'B', 'A', 'C#', 'D#']],
    ['E', UnstableChords.D7, ['E', 'G#', 'B', 'D'], ['F#', 'B', 'A', 'C#', 'D']],
    ['E', UnstableChords.D7b5, ['E', 'G#', 'A#', 'D'], ['F#', 'B', 'A', 'C#', 'D']],
    ['E', MajorChords.Maj7, ['E', 'G#', 'B', 'D#'], ['F#', 'B', 'A', 'C#', 'D#']],
    ['E', MajorChords.MajAdd9, ['E', 'G#', 'B', 'D#', 'F#'], ['F#', 'B', 'A', 'C#', 'D#']],
    ['E', UnstableChords.Dim7, ['E', 'G', 'A#', 'C#'], ['F', 'G', 'A#', 'A', 'C#', 'D']],
    ['E', UnstableChords.Aug, ['E', 'G#', 'C'], ['E', 'G#', 'C']],
  ],
  [
    ['F', MinorChords.Minor, ['F', 'G#', 'C'], ['G', 'A#', 'C', 'C#', 'D#']],
    ['F', MinorChords.M7, ['F', 'G#', 'C', 'D#'], ['G', 'A#', 'C', 'C#', 'D#']],
    ['F', UnstableChords.M9, ['F', 'G#', 'C', 'D#', 'G'], ['G', 'A#', 'C', 'C#', 'D#']],
    ['F', UnstableChords.Min7b5, ['F', 'G#', 'B', 'D#'], ['G', 'B', 'A#', 'C#', 'D#']],
    ['F', MinorChords.Madd9, ['F', 'G#', 'C', 'D#', 'G'], ['G', 'C', 'A#', 'C#', 'D#']],
    ['F', MajorChords.Major, ['F', 'A', 'C'], ['G', 'C', 'A#', 'D', 'E']],
    ['F', UnstableChords.D7, ['F', 'A', 'C', 'D#'], ['G', 'C', 'A#', 'D', 'D#']],
    ['F', UnstableChords.D7b5, ['F', 'A', 'B', 'D#'], ['G', 'C', 'A#', 'D', 'D#']],
    ['F', MajorChords.Maj7, ['F', 'A', 'C', 'E'], ['G', 'C', 'A#', 'D', 'E']],
    ['F', MajorChords.MajAdd9, ['F', 'A', 'C', 'E', 'G'], ['G', 'C', 'A#', 'D', 'E']],
    ['F', UnstableChords.Dim7, ['F', 'G#', 'B', 'D'], ['F#', 'G#', 'B', 'A#', 'D', 'D#']],
    ['F', UnstableChords.Aug, ['F', 'A', 'C#'], ['F', 'A', 'C#']],
  ],
  [
    ['F#', MinorChords.Minor, ['F#', 'A', 'C#'], ['G#', 'B', 'C#', 'D', 'E']],
    ['F#', MinorChords.M7, ['F#', 'A', 'C#', 'E'], ['G#', 'B', 'C#', 'D', 'E']],
    ['F#', UnstableChords.M9, ['F#', 'A', 'C#', 'E', 'G#'], ['G#', 'B', 'C#', 'D', 'E']],
    ['F#', UnstableChords.Min7b5, ['F#', 'A', 'C', 'E'], ['G#', 'C', 'B', 'D', 'E']],
    ['F#', MinorChords.Madd9, ['F#', 'A', 'C#', 'E', 'G#'], ['G#', 'C#', 'B', 'D', 'E']],
    ['F#', MajorChords.Major, ['F#', 'A#', 'C#'], ['G#', 'C#', 'B', 'D#', 'F']],
    ['F#', UnstableChords.D7, ['F#', 'A#', 'C#', 'E'], ['G#', 'C#', 'B', 'D#', 'E']],
    ['F#', UnstableChords.D7b5, ['F#', 'A#', 'C', 'E'], ['G#', 'C#', 'B', 'D#', 'E']],
    ['F#', MajorChords.Maj7, ['F#', 'A#', 'C#', 'F'], ['G#', 'C#', 'B', 'D#', 'F']],
    ['F#', MajorChords.MajAdd9, ['F#', 'A#', 'C#', 'F', 'G#'], ['G#', 'C#', 'B', 'D#', 'F']],
    ['F#', UnstableChords.Dim7, ['F#', 'A', 'C', 'D#'], ['G', 'A', 'C', 'B', 'D#', 'E']],
    ['F#', UnstableChords.Aug, ['F#', 'A#', 'D'], ['F#', 'A#', 'D']],
  ],
  [
    ['G', MinorChords.Minor, ['G', 'A#', 'D'], ['A', 'C', 'D', 'D#', 'F']],
    ['G', MinorChords.M7, ['G', 'A#', 'D', 'F'], ['A', 'C', 'D', 'D#', 'F']],
    ['G', UnstableChords.M9, ['G', 'A#', 'D', 'F', 'A'], ['A', 'C', 'D', 'D#', 'F']],
    ['G', UnstableChords.Min7b5, ['G', 'A#', 'C#', 'F'], ['A', 'C#', 'C', 'D#', 'F']],
    ['G', MinorChords.Madd9, ['G', 'A#', 'D', 'F', 'A'], ['A', 'D', 'C', 'D#', 'F']],
    ['G', MajorChords.Major, ['G', 'B', 'D'], ['A', 'D', 'C', 'E', 'F#']],
    ['G', UnstableChords.D7, ['G', 'B', 'D', 'F'], ['A', 'D', 'C', 'E', 'F']],
    ['G', UnstableChords.D7b5, ['G', 'B', 'C#', 'F'], ['A', 'D', 'C', 'E', 'F']],
    ['G', MajorChords.Maj7, ['G', 'B', 'D', 'F#'], ['A', 'D', 'C', 'E', 'F#']],
    ['G', MajorChords.MajAdd9, ['G', 'B', 'D', 'F#', 'A'], ['A', 'D', 'C', 'E', 'F#']],
    ['G', UnstableChords.Dim7, ['G', 'A#', 'C#', 'E'], ['G#', 'A#', 'C#', 'C', 'E', 'F']],
    ['G', UnstableChords.Aug, ['G', 'B', 'D#'], ['G', 'B', 'D#']],
  ],
  [
    ['G#', MinorChords.Minor, ['G#', 'B', 'D#'], ['A#', 'C#', 'D#', 'E', 'F#']],
    ['G#', MinorChords.M7, ['G#', 'B', 'D#', 'F#'], ['A#', 'C#', 'D#', 'E', 'F#']],
    ['G#', UnstableChords.M9, ['G#', 'B', 'D#', 'F#', 'A#'], ['A#', 'C#', 'D#', 'E', 'F#']],
    ['G#', UnstableChords.Min7b5, ['G#', 'B', 'D', 'F#'], ['A#', 'D', 'C#', 'E', 'F#']],
    ['G#', MinorChords.Madd9, ['G#', 'B', 'D#', 'F#', 'A#'], ['A#', 'D#', 'C#', 'E', 'F#']],
    ['G#', MajorChords.Major, ['G#', 'C', 'D#'], ['A#', 'D#', 'C#', 'F', 'G']],
    ['G#', UnstableChords.D7, ['G#', 'C', 'D#', 'F#'], ['A#', 'D#', 'C#', 'F', 'F#']],
    ['G#', UnstableChords.D7b5, ['G#', 'C', 'D', 'F#'], ['A#', 'D#', 'C#', 'F', 'F#']],
    ['G#', MajorChords.Maj7, ['G#', 'C', 'D#', 'G'], ['A#', 'D#', 'C#', 'F', 'G']],
    ['G#', MajorChords.MajAdd9, ['G#', 'C', 'D#', 'G', 'A#'], ['A#', 'D#', 'C#', 'F', 'G']],
    ['G#', UnstableChords.Dim7, ['G#', 'B', 'D', 'F'], ['A', 'B', 'D', 'C#', 'F', 'F#']],
    ['G#', UnstableChords.Aug, ['G#', 'C', 'E'], ['G#', 'C', 'E']],
  ],
] as ChordModel[][];
